module.exports = __webpack_public_path__ + "static/snowlogo-f974437c90a4e59d7d44473cab9721b9.png";